<div class="security-container" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column center">
        <app-single-card>
            <div fxLayout="row" fxLayoutAlign="center center">
                <img class="logo" [src]="Logo" alt="Laboratory Logo" />
            </div>
            <form (submit)="formSubmitted($event)">
                <p class="security-hint">
                    <strong>Enter your email address and we will send you instructions to reset your password.</strong>
                </p>
                <dx-form [formData]="formData" [readOnly]="false" [labelLocation]="'top'">
                    <dxi-item dataField="email">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                        <dxi-validation-rule type="email"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item
                        itemType="button"
                        horizontalAlignment="center"
                        [buttonOptions]="{ text: 'Send', useSubmitBehavior: true }"
                    >
                    </dxi-item>
                </dx-form>
                <p class="security-hint-left">Helpful tips to access your {{ Lab }} web portal account:</p>
                <ul class="security-hint-left">
                    <li>
                        If you forgot your password, please enter your email address above and click the Send button.
                    </li>
                    <li>After clicking Send, check your email account for the email from {{ Lab }}.</li>
                    <li>Click "Reset password now".</li>
                </ul>
                <div class="link-container">
                    <a routerLink="/login">Go back</a>
                </div>
            </form>
        </app-single-card>
    </div>
</div>

<dx-popup
    class="popup"
    [width]="400"
    [height]="100"
    [showTitle]="false"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">
        <p>Please check your email and click on the link to change your password. Note that this link will be valid for 10 minutes</p>
        <div fxLayout="row" fxLayoutAlign="end">
            <dx-button text="OK" (click)="redirectToLogin()" height="26px" width="60px"></dx-button>
        </div>
    </div>
</dx-popup>
